import { Injectable, inject } from '@angular/core';
import { EnvToken } from '@app/core/env.tokens';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AllZipCodesRegion } from '@models/Location/allZipCodesRegion.model';

@Injectable({
  providedIn: 'root',
})
export class CityService {
  protected readonly env = inject(EnvToken);

  baseHref = `${this.env.dashboardBaseRef}api/${this.env.apiPrefix}location/cities`;
  constructor(private http: HttpClient) {}

  findByRegionAndCity(
    regionSlug: string,
    citySlug: string,
  ): Observable<AllZipCodesRegion> {
    const url = `${this.baseHref}/all-zip-codes`;
    let params = new HttpParams();
    if (regionSlug) {
      params = params.append('region', regionSlug);
    }
    if (citySlug) {
      params = params.append('city', citySlug);
    }
    return this.http.get<AllZipCodesRegion>(url, { params });
  }
}
